module.exports = __webpack_public_path__ + "img/144c5e1.png";